import styled from "styled-components";

export const ContainerEmptyState = styled.div`
  margin-top: ${(props) => props.marginTop};
  padding-left: 16px;
  padding-right: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .emptyStatusTitle {
    font-weight: 700;
    font-size: 18px;
    line-height: 28px;
    color: ${(props) => props?.tema?.primaryColor};
    text-align: center;
    margin-bottom: 8px;
    margin-top: 24px;
    display: block;
  }

  .emptyStatusText {
    font-size: 16px;
    line-height: 24px;
    color: #4d4d4d;
    text-align: center;
    display: block;
  }
`;
